import React, { useContext } from 'react';
import styled from 'styled-components';
import { CheckBoxField, FlexColumn, BodySemiBold, Tooltip } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import withPrivileges from '@ubeya/shared-web/hoc/withPrivileges';
import privileges from '@ubeya/shared-web/privileges';

const Content = styled.div`
  ${responsiveFields.mobile};
`;

const CheckBox = ({ name, title, subTitle, disabled }) => (
  <CheckBoxField name={name} disabled={disabled}>
    <FlexColumn>
      <BodySemiBold>{title}</BodySemiBold>
      {subTitle}
    </FlexColumn>
  </CheckBoxField>
);

const ChatCheckBox = withPrivileges(({ disabled, ...props }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Tooltip body={t('chatPrivilegeDisabledTooltip')} disabled={!disabled}>
      <div>
        <CheckBox {...props} disabled={disabled} />
      </div>
    </Tooltip>
  );
});

const NotificationsSettings = ({ showClientSelfServiceBooking }) => {
  const { t, enableClientTimesheetApprovalNotification } = useContext(ConfigContext);

  return (
    <Content>
      <ChatCheckBox
        requiredPrivileges={[privileges.VIEW_CHAT]}
        disableProtected
        name="config.isChatMessages"
        title={t('chatMessageOnMail')}
        subTitle={t('chatMessageOnMailDescription')}
      />

      <ChatCheckBox
        requiredPrivileges={[privileges.VIEW_CHAT]}
        disableProtected
        name="config.isChatPushNotifications"
        title={t('chatPushNotification')}
        subTitle={t('chatPushNotificationDescription')}
      />

      <CheckBox name="config.isJobApplications" title={t('jobApplication')} subTitle={t('jobApplicationDescription')} />

      <CheckBox
        name="config.isOrderHub"
        title={t('orderHubNotification')}
        subTitle={t('orderHubNotificationDescription')}
      />

      <CheckBox
        name="config.isEmployeePoorReview"
        title={t('employeePoorReviewNotifications')}
        subTitle={t('employeePoorReviewNotificationsBody')}
      />

      <CheckBox
        name="config.isClientMovedEmployeeShift"
        title={t('clientMovedEmployeeShiftNotifications')}
        subTitle={t('clientMovedEmployeeShiftNotificationsBody')}
      />

      <CheckBox
        name="config.isClientChangedLocation"
        title={t('clientChangedLocationNotifications')}
        subTitle={t('clientChangedLocationNotificationsBody')}
      />

      <CheckBox
        name="config.isGroupJoiningRequest"
        title={t('groupJoinRequest')}
        subTitle={t('groupJoinRequestDescription')}
      />

      <CheckBox
        name="config.isRequestNewAbsence"
        title={t('absenceRequests')}
        subTitle={t('absenceRequestsDescription')}
      />

      <CheckBox name="config.isRequestNewLeave" title={t('leaveRequests')} subTitle={t('leaveRequestsDescription')} />

      <CheckBox
        name="config.isRequestRelease"
        title={t('shiftReleaseRequests')}
        subTitle={t('shiftReleaseRequestsDescription')}
      />

      <CheckBox
        name="config.isRequestSwapShift"
        title={t('shiftSwapRequests')}
        subTitle={t('shiftSwapRequestsDescription')}
      />

      <CheckBox
        name="config.isRecievingMailEmployeesNotClockedIn"
        title={t('recievingMailEmployeesNotClockedIn')}
        subTitle={t('recievingMailEmployeesNotClockedInDescription')}
      />

      <CheckBox
        name="config.isEmployeeDeleteSelf"
        title={t('leaveAccountNotifications')}
        subTitle={t('leaveAccountNotificationsBody')}
      />

      <CheckBox
        name="config.isBookingFulfillmentNotification"
        title={t('bookingFulfillmentNotification')}
        subTitle={t('bookingFulfillmentNotificationDescription')}
      />

      <CheckBox
        name="config.isBookerTimesheetReminderEnabled"
        title={t('bookerTimesheetReminderEnabled')}
        subTitle={t('bookerTimesheetReminderEnabledDescription')}
      />

      {enableClientTimesheetApprovalNotification && (
        <CheckBox
          name="config.isClientTimesheetApprovalDeclineNotification"
          title={t('clientTimesheetApprovalDeclineNotification')}
          subTitle={t('clientTimesheetApprovalDeclineNotificationDescription')}
        />
      )}

      {showClientSelfServiceBooking && (
        <CheckBox
          name="config.isClientSelfServiceBooking"
          title={t('clientSelfServiceBookingNotification')}
          subTitle={t('clientSelfServiceBookingNotificationDescription')}
        />
      )}
    </Content>
  );
};

export default NotificationsSettings;
